{
  "version": 1,
  "asset_id": "4ae47628-4010-43ff-a1c3-37e05b634ac9",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/4ae47628-4010-43ff-a1c3-37e05b634ac9/notice-deficiency.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/4ae47628-4010-43ff-a1c3-37e05b634ac9/notice-deficiency.jpg",
  "original_filename": "notice-deficiency.jpg",
  "size": 147405,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:42Z"
}
